<template>
  <v-app dark>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <v-row>
          <v-col
            cols="12">
            Věk první menstruace
          </v-col>
          <v-col
            cols="auto">
            <!-- <VTextFieldWithValidation
            v-model="form.ageMenstruation"
            label="Zadejte věk"
            mode="lazy"
            customClass="mt-0 pt-0"
          /> -->
            <v-text-field
              v-model="form.ageMenstruation"
              type="number"
              class="mt-0 pt-0"
              label="Zadejte věk" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Cyklus
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.cycle.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Pravidelný"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Nepravidelný"
                       :value="2" />
            </VRadioWithValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Věk menopauzy
          </v-col>
          <v-col
            class="my-0 py-0"
            cols="12">
            <v-row>
              <v-col
                cols="auto">
                <VRadioWithValidation
                  rules="required"
                  v-model="form.ageMenopause.status"
                  row
                  custom-class="mt-0 pt-0">
                  <v-radio color="blue lighten-1"
                           label="Ano"
                           :value="1" />
                  <v-radio color="blue lighten-1"
                           label="Ne"
                           :value="2" />
                </VRadioWithValidation>
              </v-col>
              <v-col
                cols="auto">
                <v-text-field
                  :disabled="form.ageMenopause.status !== 1"
                  v-model="form.ageMenopause.value"
                  class="mt-0 pt-0"
                  label="Zadejte věk" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Užíváte/užívala jste antikoncepci?
          </v-col>
          <v-col
            class="my-0 py-0"
            cols="12">
            <v-row>
              <v-col
                cols="auto">
                Hormonální
              </v-col>
              <v-col
                cols="auto">
                <VRadioWithValidation
                  rules="required"
                  v-model="form.hormonalAnticonception.status"
                  row
                  custom-class="mt-0 pt-0">
                  <v-radio color="blue lighten-1"
                           label="Ano"
                           :value="1" />
                  <v-radio color="blue lighten-1"
                           label="Ne"
                           :value="2" />
                  <v-radio color="blue lighten-1"
                           label="Nechci uvést"
                           :value="4" />
                </VRadioWithValidation>
              </v-col>
              <v-col
                cols="auto">
                <VTextFieldWithValidation
                  :rules="form.hormonalAnticonception.status == '1' ? 'required' : ''"
                  v-model="form.hormonalAnticonception.value"
                  label="Jaké?"
                  mode="lazy"
                  custom-class="mt-0 pt-0"
                  :disabled="form.hormonalAnticonception.status != '1'" />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="my-0 py-0"
            cols="12">
            <v-row>
              <v-col
                cols="auto">
                Nitroděl. tělísko
              </v-col>
              <v-col
                cols="auto">
                <VRadioWithValidation
                  rules="required"
                  v-model="form.intrauterineAnticonception.status"
                  row
                  custom-class="mt-0 pt-0">
                  <v-radio color="blue lighten-1"
                           label="Ano"
                           :value="1" />
                  <v-radio color="blue lighten-1"
                           label="Ne"
                           :value="2" />
                  <v-radio color="blue lighten-1"
                           label="Nechci uvést"
                           :value="4" />
                </VRadioWithValidation>
              </v-col>
              <v-col
                cols="auto">
                <VTextFieldWithValidation
                  :rules="form.intrauterineAnticonception.status == '1' ? 'required' : ''"
                  v-model="form.intrauterineAnticonception.value"
                  label="Typ tělíska a jak dlouho?"
                  mode="lazy"
                  custom-class="mt-0 pt-0"
                  :disabled="form.intrauterineAnticonception.status != '1'" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Trpíte často gynekologickými obtížemi (záněty, výtoky, cysty a jiné )
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.gynecologicalProblems.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       :value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.gynecologicalProblems.status == '1' ? 'required' : ''"
              v-model="form.gynecologicalProblems.value"
              label="Jakými?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.gynecologicalProblems.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Prodělala jste gynekologickou operaci?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.gynecologicalOperation.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       :value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.gynecologicalOperation.status == '1' ? 'required' : ''"
              v-model="form.gynecologicalOperation.value"
              label="Jakou?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.gynecologicalOperation.status != '1'" />
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.gynecologicalOperation.status == '1' ? 'required' : ''"
              v-model="form.gynecologicalOperation.valueAge"
              label="V jakém věku?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.gynecologicalOperation.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Vyskytlo se u Vás nádorové onemocnění prsu?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.breastCancer.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       :value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.breastCancer.status == '1' ? 'required' : ''"
              v-model="form.breastCancer.valueAge"
              label="V jakém věku?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.breastCancer.status != '1'" />
          </v-col>
          <v-col
            cols="12">
            <VRadioWithValidation
              :disabled="form.breastCancer.status != '1'"
              :rules="form.breastCancer.status == '1' ? 'required' : ''"
              v-model="form.breastCancer.valueType"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Jednostranné"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Oboustranné"
                       :value="2" />
            </VRadioWithValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Vyskytlo se u Vás nádorové onemocnění vaječníku nebo vejcovodu?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.ovarianCancer.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       :value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.ovarianCancer.status == '1' ? 'required' : ''"
              v-model="form.ovarianCancer.valueAge"
              label="V jakém věku?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.ovarianCancer.status != '1'" />
          </v-col>
          <v-col
            cols="12">
            <VRadioWithValidation
              :disabled="form.ovarianCancer.status != '1'"
              :rules="form.ovarianCancer.status == '1' ? 'required' : ''"
              v-model="form.ovarianCancer.valueType"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Jednostranné"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Oboustranné"
                       :value="2" />
            </VRadioWithValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Vyskytlo se u Vás jiné nádorové onemocnění ?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.otherCancer.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       :value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.otherCancer.status == '1' ? 'required' : ''"
              v-model="form.otherCancer.valueAge"
              label="V jakém věku?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.otherCancer.status != '1'" />
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.otherCancer.status == '1' ? 'required' : ''"
              v-model="form.otherCancer.value"
              label="Jaké?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.otherCancer.status != '1'" />
          </v-col>
          <v-col
            cols="auto">
            <v-btn @click="submit()"
                   type="submit"
                   x-large
                   depressed
                   height="68px"
                   class="px-12 white--text"
                   color="blue lighten-1">
              Uložit
            </v-btn>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<script>
export default {
  name: 'TheGynecology',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: {
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',

        ageMenstruation: null,
        cycle: {
          status: null,
          value: 'string'
        },
        ageMenopause: {
          status: null,
          value: '',
        },
        hormonalAnticonception: {
          status: null,
          value: ''
        },
        intrauterineAnticonception: {
          status: null,
          value: ''
        },
        gynecologicalProblems: {
          status: null,
          value: ''
        },
        gynecologicalOperation: {
          status: null,
          value: ''
        },
        breastCancer: {
          status: null,
          value: ''
        },
        ovarianCancer: {
          status: null,
          value: ''
        },
        otherCancer: {
          status: null,
          value: ''
        },
      },
    };
  },
  computed: {
    formtosend() {
      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        ageMenstruation: this.form.ageMenstruation ? Number(this.form.ageMenstruation) : 1,
        cycle: {
          status: this.form.cycle.status,
          value: this.form.cycle.value
        },
        ageMenopause: {
          status: this.form.ageMenopause.status,
          value: this.form.ageMenopause.value,
        },
        hormonalAnticonception: {
          status: this.form.hormonalAnticonception.status,
          value: this.form.hormonalAnticonception.value
        },
        intrauterineAnticonception: {
          status: this.form.intrauterineAnticonception.status,
          value: this.form.intrauterineAnticonception.value
        },
        gynecologicalProblems: {
          status: this.form.gynecologicalProblems.status,
          value: this.form.gynecologicalProblems.value
        },
        gynecologicalOperation: {
          status: this.form.gynecologicalOperation.status,
          value: JSON.stringify({
            what: this.form.gynecologicalOperation.value,
            age: this.form.gynecologicalOperation.valueAge,
          })
        },
        breastCancer: {
          status: this.form.breastCancer.status,
          value: JSON.stringify({
            valueAge: this.form.breastCancer.valueAge,
            valueType: this.form.breastCancer.valueType,
          })
        },
        ovarianCancer: {
          status: this.form.ovarianCancer.status,
          value: JSON.stringify({
            valueAge: this.form.ovarianCancer.valueAge,
            valueType: this.form.ovarianCancer.valueType,
          })
        },
        otherCancer: {
          status: this.form.otherCancer.status,
          value: JSON.stringify({
            what: this.form.otherCancer.value,
            age: this.form.otherCancer.valueAge,
          })
        }
      });
    }
  },
  methods: {
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.formtosend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/gynecologywomanpart', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  created() {
    this.axios.get('admin/questionnaires/gynecologywomanpart', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;

      this.form = {
        ageMenstruation: data.ageMenstruation === '1' || data.ageMenstruation === 1 ? null : data.ageMenstruation,
        cycle: {
          status: data.cycle.status,
          value: 'string'
        },
        ageMenopause: {
          status: data.ageMenopause.status,
          value: data.ageMenopause.value,
        },
        hormonalAnticonception: {
          status: data.hormonalAnticonception.status,
          value: data.hormonalAnticonception.value
        },
        intrauterineAnticonception: {
          status: data.intrauterineAnticonception.status,
          value: data.intrauterineAnticonception.value
        },
        gynecologicalProblems: {
          status: data.gynecologicalProblems.status,
          value: data.gynecologicalProblems.value
        },
        gynecologicalOperation: {
          status: data.gynecologicalOperation.status,
          value: JSON.parse(data.gynecologicalOperation.value).what,
          valueAge: JSON.parse(data.gynecologicalOperation.value).age
        },
        breastCancer: {
          status: data.breastCancer.status,
          valueAge: JSON.parse(data.breastCancer.value).valueAge,
          valueType: JSON.parse(data.breastCancer.value).valueType,
        },
        ovarianCancer: {
          status: data.ovarianCancer.status,
          valueAge: JSON.parse(data.ovarianCancer.value).valueAge,
          valueType: JSON.parse(data.ovarianCancer.value).valueType,
        },
        otherCancer: {
          status: data.otherCancer.status,
          value: JSON.parse(data.otherCancer.value).what,
          valueAge: JSON.parse(data.otherCancer.value).age,
        },
      };
    });
  }
};
</script>
